/**
 * @file ステップ (学年) の切り替えタブ。お子さんの「いまここ」のステップにバッジを出す。
 */

import type { Stage } from "../model";
import "./study.css";

export function StepTabs({
  stages,
  selectedId,
  currentStageId,
  onSelect,
}: {
  stages: Stage[];
  selectedId: string;
  currentStageId?: string;
  onSelect: (stageId: string) => void;
}) {
  return (
    <div className="study-steps" role="tablist" aria-label="ステップ">
      {stages.map((s) => {
        const selected = s.id === selectedId;
        const isCurrent = s.id === currentStageId;
        return (
          <button
            key={s.id}
            type="button"
            role="tab"
            aria-selected={selected}
            id={`study-step-tab-${s.id}`}
            aria-controls={`study-step-panel-${s.id}`}
            className="study-step-tab"
            onClick={() => onSelect(s.id)}
          >
            <span className="study-step-tab-period">{s.period}</span>
            <span className="study-step-tab-sub">
              {s.label}
              {isCurrent ? <span className="study-now-badge">いまここ</span> : null}
            </span>
          </button>
        );
      })}
    </div>
  );
}
